export default __webpack_public_path__ + "static/media/x.982b8ef4.svg";